import { FormProvider } from 'react-hook-form'

import { LeaveConfirmation, Tooltip } from 'ui/components'
import { Page, PageFace } from 'ui/components/Page'
import { SarEdit } from '~bank-bsa-reporting/types'

import { Footer, Form } from './components'
import { useDelete, useRouting, useSARForm } from './hooks'

import { s } from './styles'

const title = `OMB No. 1506-0065 (Report); OMB No. 1506-0001, 1506-0006, 1506-0015, 1506-0019, 1506-0029, and
1506-0061 (Regulations) Version Number: 1.2`

export const ManageSARPage = (props: { id: number; data: SarEdit }) => {
  const { id, data } = props
  const { comeBackToDetailsOrReturnUrl } = useRouting()
  const { formApi, isFormDirty, isSubmitting, handleSubmit } = useSARForm(data)
  const { startDeletion, DeleteConfirmation } = useDelete(id, () => formApi.reset())

  return (
    <FormProvider {...formApi}>
      <LeaveConfirmation preventLeaving={isFormDirty && !isSubmitting}>
        <DeleteConfirmation />
        <Page
          face={PageFace.SECONDARY}
          title={
            <Tooltip id="sar_title" type="dark" event="hover" content={title}>
              <s.TooltipBody>{title}</s.TooltipBody>
            </Tooltip>
          }
          subTitle="SAR"
          footer={
            <Footer
              onSubmit={handleSubmit}
              isSarEditForm={id > 0}
              onDelete={startDeletion}
              onCancel={comeBackToDetailsOrReturnUrl}
              isSubmitting={isSubmitting}
            />
          }
        >
          {!!data && <Form />}
        </Page>
      </LeaveConfirmation>
    </FormProvider>
  )
}
